const qpstat_initstate = [];

export const qpStatReducer = (state = qpstat_initstate, action) => {
  switch (action.type) {
    case "FETCH_QPSTATS":
      return action.payload.data;
    case "DELETE_QPSTATS":
      return qpstat_initstate;
    default:
      return state;
  }
};

export const qpStatSumReducer = (state = qpstat_initstate, action) => {
  switch (action.type) {
    case "FETCH_QPSTATS_SUM":
      return action.payload.data;
    case "DELETE_QPSTATS_SUM":
      return qpstat_initstate;
    default:
      return state;
  }
};

export const getTeachCodeRange = (state = qpstat_initstate, action) => {
  switch (action.type) {
    case "GET_TEACHER_CODE_RANGE":
      return action.payload.data;
    default:
      return state;
  }
};

export const getfbaordName = (state = qpstat_initstate, action) => {
  switch (action.type) {
    case "FETCH_FBOARD_NAME":
      return action.payload.data;
    default:
      return state;
  }
};

export const getTeachCodeOnBoard = (state = qpstat_initstate, action) => {
  switch (action.type) {
    case "GET_TEACHCODE_ONBOARD":
      return action.payload.data;
    default:
      return state;
  }
};
